import { render, staticRenderFns } from "@/shared/components/datepicker/datepicker.pug?vue&type=template&id=1a8ff41c&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/shared/components/datepicker/datepicker.scss?vue&type=style&index=0&id=1a8ff41c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ff41c",
  null
  
)

export default component.exports